<div fxLayout="column" fxFlex="100" fxLayoutGap="15px">
    <div fxLayout="column" fxLayoutAlign="center center">
      <h3  fxLayoutAlign="center center">Zmień status zgłoszenia </h3>
    </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center" fxLayoutGap="15px">
      <button (click)="successChange()" mat-raised-button class="report-button"><mat-icon>check</mat-icon> <span> Sukces </span></button>
      <button (click)="failureChange()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Strata</span></button>
      <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
    </div>
  </div>
</div>
